// extracted by mini-css-extract-plugin
export default {"container":"collapse_container__qY8xr"};